import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/mail_gray_60.png'


const _withScopeId = n => (_pushScopeId("data-v-45e880f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "modal-title" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createTextVNode(" Group invitation ")
], -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_7 = { class: "invite-header" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "From", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "To", -1))
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "address"
}
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = {
  key: 0,
  class: "address"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Address", -1))
const _hoisted_16 = { class: "address-input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Sent", -1))
const _hoisted_18 = { class: "invite-date" }
const _hoisted_19 = {
  key: 0,
  class: "alert alert-success alert-sm resent-alert"
}
const _hoisted_20 = {
  key: 1,
  class: "alert alert-success alert-sm"
}
const _hoisted_21 = {
  key: 2,
  class: "alert alert-warning alert-sm cancelled-alert"
}
const _hoisted_22 = { class: "invite-body" }
const _hoisted_23 = { class: "invite-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Join this group: ", -1))
const _hoisted_25 = {
  key: 0,
  class: "invite-profile"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, " Join as this person: ", -1))
const _hoisted_27 = {
  key: 1,
  class: "invite-role"
}
const _hoisted_28 = { class: "form-label" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "message"
}
const _hoisted_31 = { class: "form-label" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "help-text" }, "(recommended)", -1))
const _hoisted_33 = {
  key: 1,
  class: "message"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Message", -1))
const _hoisted_35 = { class: "modal-footer" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = ["disabled", "onClick"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]

import { computed, nextTick, ref } from 'vue'
import { DateTimeUtil } from '@/util/LuxonUtil'
import { FamilyGroupInvite, GroupMemberRole, InvitationResult, ItemPermissions, UserGender } from '@/gp/GroupAdminModel'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useUserStore } from '@/gp/UserStore'
import { usePersonStore } from '@/rd/PersonStore'
import { useManageStore } from "@/manage/ManageStores"
import { useContactStore } from "@/manage/contacts/ContactStore"
import { LoadMode } from '@/util/AsyncData'
import { AsyncUtil } from '@/util/AsyncUtil'
import { CompositeId } from '@/rd/CompositeId'
import { useTokenManager } from '@/auth/TokenManager'
import { Modal as BsModal } from 'bootstrap'
import { SendIcon } from '@zhuowenli/vue-feather-icons'
import { DateTime } from 'luxon'
import { PersonName } from '@/rd/ResearchDataModel'
import FamilyGroupInviteRecipient from './FamilyGroupInviteRecipient.vue'
import ContactProviderSelector from '@/manage/contacts/ContactProviderSelector.vue'
import FamilyGroupItem from './FamilyGroupItem.vue'
import FamilyGroupInviteProfile from './FamilyGroupInviteProfile.vue'
import ProfileCard from '@/manage/ProfileCard.vue'
import Spinner from '@/util/Spinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupInviteModal',
  setup(__props, { expose: __expose }) {

__expose({
  openNew,
  openEdit,
  close,
})

const inviteStore = useFamilyGroupInviteStore()
const familyGroupStore = useFamilyGroupStore()
const dataGroupStore = useDataGroupStore()
const personStore = usePersonStore()
const userStore = useUserStore()
const manageStore = useManageStore()
const contactStore = useContactStore()
const tokenManager = useTokenManager()

const inviteRef = ref<FamilyGroupInvite>()
const recipientEmailRef = ref<string>()
const recipientInputRef = ref<InstanceType<typeof FamilyGroupInviteRecipient>>()
const isRecruiterRef = ref(false)
const addMessageRef = ref(false)
const busyRef = ref(false)
const modalRef = ref<HTMLElement>()

const permissionsRef = computed(() => isNewRef.value ? ItemPermissions.Owner : 
  inviteStore.getAsyncPermissions(inviteRef.value?.id, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const senderUserRef = computed(() => userStore.getAsyncUser(inviteRef.value?.senderUserId)?.data) // loaded by parent
const recipientProfileRef = computed(() => {
  const profileGroup = dataGroupStore.getAsyncGroup(inviteRef.value?.profileDataGroupId)?.data // loaded by parent
  return personStore.getAsyncPerson(profileGroup?.startItemId, LoadMode.EnsureLoaded)?.data
})
const recipientUserRef = computed(() => {
  const profileGroup = dataGroupStore.getAsyncGroup(inviteRef.value?.profileDataGroupId)?.data // loaded by parent
  const profileOwner = userStore.getAsyncUser(profileGroup?.ownerId)?.data // loaded by parent (if exists)
  return (profileGroup?.id == profileOwner?.profileDataGroupId) ? profileOwner : undefined
})

const isNewRef = computed(() => !inviteRef.value?.id)
const isForSelfRef = computed(() => inviteRef.value?.recipientUserId == tokenManager.current.userId)
const isAcceptedRef = computed(() => inviteRef.value?.result === InvitationResult.Accepted)

const showInviteProfileRef = computed(() => inviteRef.value?.profileDataGroupId && inviteRef.value?.profileDataGroupId != recipientUserRef.value?.profileDataGroupId)

const familyGroupPermissionsRef = computed(() => 
  familyGroupStore.getAsyncPermissions(inviteRef.value?.familyGroupId, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None)
const canSetRecruiterRef = computed(() => isNewRef.value && (familyGroupPermissionsRef.value & ItemPermissions.Owner))

const showSendRef = computed(() => isNewRef.value)
const isValidRecipientRef = computed(() => !!recipientUserRef.value || !!recipientInputRef.value?.validate())
const enableSendRef = computed(() => showSendRef.value && !busyRef.value && isValidRecipientRef.value)

const MinResendInterval = { days: 3 }
const nextResendDateRef = computed(() => inviteRef.value?.lastSentDate?.plus(MinResendInterval))
const showResendRef = computed(() => inviteRef.value && !isNewRef.value && !busyRef.value && inviteRef.value.isPending &&
  inviteRef.value.senderUserId == tokenManager.current.userId)
const enableResendRef = computed(() => showResendRef.value && DateTime.utc() > nextResendDateRef.value! && !busyRef.value)
const showResentAlertRef = ref(false)

const showCancelRef = computed(() => !isNewRef.value && inviteRef.value?.result == InvitationResult.Pending && 
  (permissionsRef.value & ItemPermissions.Owner) > 0)
const enableCancelRef = computed(() => showCancelRef.value && !busyRef.value)

const canAcceptRef = computed(() => inviteRef.value && isForSelfRef.value && inviteRef.value.result == InvitationResult.Pending)

async function openNew(familyGroupId: string, profilePersonId: string) {
  const inv = new FamilyGroupInvite()
  inv.familyGroupId = familyGroupId
  inv.senderUserId = tokenManager.current.userId
  inv.profileDataGroupId = CompositeId.getGroupId(profilePersonId)
  inviteRef.value = inv
  recipientEmailRef.value = manageStore.inviteAddresses.get(profilePersonId!)
  isRecruiterRef.value = false

  resetInteractiveState()

  // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
  // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
  BsModal.getOrCreateInstance(modalRef.value!).show()

  await nextTick()
  recipientInputRef.value?.focus()  
}

function openEdit(inviteId: string) {
  inviteRef.value = inviteStore.getAsyncInvite(inviteId)?.data // loaded by parent
  recipientEmailRef.value = inviteRef.value?.recipientEmail
  isRecruiterRef.value = inviteRef.value?.recipientRole == GroupMemberRole.Recruiter

  resetInteractiveState()
  
  // HACK: Not sure why getInstance isn't sufficient here, but sometimes it returns null because apparently the BS Modal
  // hasn't been initialized yet. Calling getOrCreateInstance seems to fix it.
  BsModal.getOrCreateInstance(modalRef.value!).show()
}

function resetInteractiveState() {
  busyRef.value = false
  showResentAlertRef.value = false
}

function close() {
  BsModal.getInstance(modalRef.value!)?.hide()
}

async function sendInvite() {
  const inv = inviteRef.value!
  inv.recipientUserId = recipientUserRef.value?.id
  inv.recipientEmail = manageStore.inviteAddresses.get(recipientProfileRef.value!.id!)
  const name = new PersonName(recipientProfileRef.value!.displayProperties.name)
  inv.recipientFirstName = name.given
  inv.recipientLastName = name.surname
  inv.recipientRole = isRecruiterRef.value ? GroupMemberRole.Recruiter : GroupMemberRole.Member
  inv.profileDisplayName = recipientProfileRef.value!.displayName
  inv.profileGender = recipientProfileRef.value!.displayProperties.gender as string as UserGender // same values

  busyRef.value = true
  await inviteStore.sendAsync(inv)
  close()
}

async function cancelInvite() {
  busyRef.value = true
  await inviteStore.cancelAsync(inviteRef.value!.id!)
  close()
}

async function resendInvite(e: Event) {
  busyRef.value = true
  const inviteId = inviteRef.value!.id! // capture this before the await

  await AsyncUtil.delay(500)
  await inviteStore.resendAsync(inviteRef.value!.id!, undefined, inviteRef.value!.senderMessage)

  busyRef.value = false
  showResentAlertRef.value = true
  // don't close
}

async function acceptInvite(e: Event) {
  busyRef.value = true
  await inviteStore.acceptAsync(inviteRef.value!.id!)
  close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    ref_key: "modalRef",
    ref: modalRef,
    "data-bs-backdrop": "static",
    tabindex: "-1"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            disabled: busyRef.value,
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          }, null, 8, _hoisted_5)
        ]),
        (inviteRef.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (!isNewRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_8,
                      _createElementVNode("div", null, _toDisplayString(senderUserRef.value?.displayName), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _hoisted_9,
                (recipientUserRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createTextVNode(_toDisplayString(recipientUserRef.value?.displayName) + " ", 1),
                      (recipientUserRef.value.email)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, "(" + _toDisplayString(recipientUserRef.value.email) + ")", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (isNewRef.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(recipientProfileRef.value?.displayName), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createTextVNode(_toDisplayString(recipientProfileRef.value?.displayName) + " ", 1),
                        (recipientEmailRef.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "(" + _toDisplayString(recipientEmailRef.value) + ")", 1))
                          : _createCommentVNode("", true)
                      ])),
                (isNewRef.value && !recipientUserRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _hoisted_15,
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(FamilyGroupInviteRecipient, {
                          ref_key: "recipientInputRef",
                          ref: recipientInputRef,
                          "profile-id": recipientProfileRef.value?.id
                        }, null, 8, ["profile-id"]),
                        _createVNode(ContactProviderSelector)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (!isNewRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(DateTimeUtil).toUserActionDate(inviteRef.value.lastSentDate)) + " (" + _toDisplayString(_unref(DateTimeUtil).toRelativePastDate(inviteRef.value.lastSentDate)) + ") ", 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              (showResentAlertRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, " Invitation resent. "))
                : _createCommentVNode("", true),
              (isAcceptedRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, " This invitation was accepted on " + _toDisplayString(_unref(DateTimeUtil).toUserActionDate(inviteRef.value?.closedDate)), 1))
                : _createCommentVNode("", true),
              (inviteRef.value.result == _unref(InvitationResult).Cancelled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, " This invitation was cancelled on " + _toDisplayString(_unref(DateTimeUtil).toUserActionDate(inviteRef.value?.closedDate)) + ". ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(FamilyGroupItem, {
                    "family-group-id": inviteRef.value.familyGroupId
                  }, null, 8, ["family-group-id"])
                ]),
                (showInviteProfileRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _hoisted_26,
                      (isNewRef.value)
                        ? (_openBlock(), _createBlock(ProfileCard, {
                            key: 0,
                            "person-id": recipientProfileRef.value?.id,
                            class: "profile-card"
                          }, null, 8, ["person-id"]))
                        : (_openBlock(), _createBlock(FamilyGroupInviteProfile, {
                            key: 1,
                            "invite-id": inviteRef.value?.id,
                            class: "profile-card"
                          }, null, 8, ["invite-id"]))
                    ]))
                  : _createCommentVNode("", true),
                (isRecruiterRef.value || canSetRecruiterRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isRecruiterRef).value = $event)),
                          disabled: !isNewRef.value,
                          class: "form-check-input"
                        }, null, 8, _hoisted_29), [
                          [_vModelCheckbox, isRecruiterRef.value]
                        ]),
                        _createTextVNode(" Can invite others ")
                      ]),
                      (isNewRef.value || enableResendRef.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createElementVNode("label", _hoisted_31, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addMessageRef).value = $event)),
                                class: "form-check-input"
                              }, null, 512), [
                                [_vModelCheckbox, addMessageRef.value]
                              ]),
                              _createTextVNode(" Add a personal message "),
                              _hoisted_32
                            ]),
                            _createElementVNode("div", {
                              id: "customMessage",
                              ref: "customMessageElemRef",
                              class: _normalizeClass(["collapse", { show: addMessageRef.value }])
                            }, [
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inviteRef.value.senderMessage) = $event)),
                                class: "form-control"
                              }, null, 512), [
                                [_vModelText, inviteRef.value.senderMessage]
                              ])
                            ], 2)
                          ]))
                        : (inviteRef.value.senderMessage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                              _hoisted_34,
                              _createElementVNode("div", null, _toDisplayString(inviteRef.value.senderMessage), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_35, [
          (showCancelRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-outline-danger secondary-action",
                disabled: !enableCancelRef.value,
                onClick: cancelInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Cancelling...")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Cancel invitation")
                    ], 64))
              ], 8, _hoisted_36))
            : _createCommentVNode("", true),
          (showSendRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "submit",
                class: "btn btn-primary",
                disabled: !enableSendRef.value,
                onClick: _withModifiers(sendInvite, ["prevent"])
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Sending...")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(SendIcon)),
                      _createTextVNode(" Send")
                    ], 64))
              ], 8, _hoisted_37))
            : _createCommentVNode("", true),
          (showResendRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-outline-primary",
                disabled: !enableResendRef.value,
                onClick: resendInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Resending...")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(SendIcon)),
                      _createTextVNode(" Resend")
                    ], 64))
              ], 8, _hoisted_38))
            : _createCommentVNode("", true),
          (canAcceptRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                type: "button",
                class: "btn btn-primary",
                disabled: busyRef.value,
                onClick: acceptInvite
              }, [
                (busyRef.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(Spinner),
                      _createTextVNode(" Accepting...")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Accept")
                    ], 64))
              ], 8, _hoisted_39))
            : _createCommentVNode("", true),
          (!showSendRef.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                type: "button",
                class: _normalizeClass(["btn", { 
              ['btn-primary']: !canAcceptRef.value,
              ['btn-outline-primary']: canAcceptRef.value,
            }]),
                disabled: busyRef.value,
                "data-bs-dismiss": "modal"
              }, " Close ", 10, _hoisted_40))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}
}

})